import { useEffect, useRef, useState } from "react";

import { useApi } from "@/lib/api";

interface AssetRow {
  id: string;
  kind: string;
  filename: string | null;
  prompt: string | null;
  metadata_json: string;
}

export function AudioCard(props: { asset_id: string; intro?: string }) {
  const api = useApi();
  const [asset, setAsset] = useState<AssetRow | null>(null);
  const [src, setSrc] = useState<string | null>(null);
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    let revoke: string | null = null;
    let cancelled = false;
    (async () => {
      try {
        const r = await api<{ asset: AssetRow }>(`/api/assets/${props.asset_id}`);
        if (cancelled) return;
        setAsset(r.asset);

        // Stream audio file with auth cookie/header. fetch+blob avoids exposing
        // Clerk Bearer token in <audio src> URL params.
        const fileRes = await fetch(`/api/assets/${props.asset_id}/file`, {
          credentials: "include",
        });
        if (!fileRes.ok) throw new Error(`file ${fileRes.status}`);
        const blob = await fileRes.blob();
        const url = URL.createObjectURL(blob);
        revoke = url;
        if (!cancelled) setSrc(url);
      } catch {
        //
      }
    })();
    return () => {
      cancelled = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.asset_id]);

  if (!asset) {
    return (
      <div className="rounded-2xl border border-neutral-200 bg-white p-3 text-sm text-neutral-400">
        Loading audio…
      </div>
    );
  }
  return (
    <div className="space-y-2 rounded-2xl border border-neutral-200 bg-white p-3">
      {props.intro && <div className="text-sm text-neutral-700">{props.intro}</div>}
      {asset.prompt && !props.intro && (
        <div className="text-xs text-neutral-500">{asset.prompt}</div>
      )}
      {src ? (
        <audio ref={audioRef} controls src={src} className="w-full" preload="metadata" />
      ) : (
        <div className="text-xs text-neutral-400">Loading audio…</div>
      )}
    </div>
  );
}
